module.exports = __webpack_public_path__ + "static/media/IMG_1364.167a1dba.jpg";